import axiosWithAuthInterceptor from '../util/axiosWithAuthInterceptor';
import { gql } from '@apollo/client';
import { apolloClient as client } from "../data-provider/graphqlDataProvider";
export async function getPaymentTransaction(humanizedId:any) {    
    const GET_PAYMENTS = gql`
    query GetPayments($where: PaymentWhereInput!) {
      payments(where: $where) {
        amount
        createdAt
        customerId
        gateway
        orderId
        paymentResultUrl
        service
        status
      }
    }
    `;

    try {
        const { data } = await client.query({
            query: GET_PAYMENTS,
            variables: {
                where: {
                    humanizedId: {
                        equals: parseInt(humanizedId)
                    }
                }
            }
        });
        return data;
    } catch (error) {
        console.error("Error fetching payment transaction:", error);
        throw error;
    }
}



export async function updateStatus(param: any) {
    return axiosWithAuthInterceptor.patch(
        `${process.env.REACT_APP_LIMOOME_SERVER}/lemonade/api/payments/${param.id}/status`,{
            status:param.status
        }).then(res => {
            return res
        })
}
